import { motion } from "framer-motion";
import { EASING, DURATION } from "@/lib/motionSystem";

export default function Dock({
  items = [],
  activeKey,
  onSelect,
  className = "",
}) {
  return (
    <div
      className={`inline-flex items-end gap-2 rounded-2xl border border-white/10 bg-[#0f172a]/65 p-2 backdrop-blur-xl ${className}`}
      data-testid="dock"
    >
      {items.map((item) => {
        const active = item.key === activeKey;
        return (
          <motion.button
            key={item.key}
            onClick={() => onSelect?.(item.key)}
            className={`relative flex min-w-[86px] flex-col items-center gap-1 rounded-xl px-3 py-2 text-xs font-medium transition-colors ${
              active
                ? "bg-indigo-500/20 text-indigo-200 border border-indigo-400/35"
                : "text-slate-300 hover:text-slate-100 border border-transparent hover:bg-white/5"
            }`}
            whileHover={{ y: -2, scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
            transition={{ duration: DURATION.hover, ease: EASING.standard }}
            data-testid={`dock-${item.key}`}
          >
            {item.icon ? <item.icon size={16} /> : null}
            <span>{item.label}</span>
            {active && (
              <motion.span
                layoutId="dock-active-dot"
                className="absolute -bottom-1 h-1.5 w-8 rounded-full bg-indigo-400"
              />
            )}
          </motion.button>
        );
      })}
    </div>
  );
}
